/**
 * Pilot feature scope that toggles the "Nmbrs Reporting" branding for the partner onboarding wizard.
 * Matches the `scope` values returned by `GET /api/v2/partner/{partnerId}/pilot-features`.
 */
export const CORE_NMBRS_LAUNCH_FEATURE_SCOPE = 'Core_NmbrsLaunch';

/**
 * Determines whether the Core_NmbrsLaunch pilot feature is available, based on the
 * JSON:API response of `GET /api/v2/partner/{partnerId}/pilot-features`.
 *
 * @param {object} pilotFeaturesResponse - The response returned by the User API.
 * @returns {boolean} `true` when the feature is available for the configured partner.
 */
export const isNmbrsLaunchFeatureAvailable = (pilotFeaturesResponse) => {
  const features = pilotFeaturesResponse?.data?.attributes?.features ?? [];
  return features.some((feature) => feature.scope === CORE_NMBRS_LAUNCH_FEATURE_SCOPE && feature.available === true);
};
